import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { useI18n } from '@udemy-v2/i18n';
import { Ribbon } from '@udemy-v2/react-notice-components';
import styles from './community-powered-ribbon.module.scss';
export function CommunityPoweredRibbon() {
  const $ = _c(5);
  const {
    gettext
  } = useI18n();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon color="inherit" size="xxsmall" glyph="rating-star" label={false} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== gettext) {
    t1 = gettext("Community powered");
    $[1] = gettext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Ribbon className={styles["community-powered-ribbon"]}>{t0}{t1}</Ribbon>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}